import InfoTaskPopup from './InfoTaskPopup';

export default InfoTaskPopup;
